var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0.923076923 L22.1538462,0.923076923 M22.1538462,23.0769231 L0,23.0769231"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M3.92307692,6.10153846 C5.78769231,8.49230769 9.23076923,12.9230769 9.23076923,12.9230769 L9.23076923,18.4615385 C9.23076923,18.9692308 9.64615385,19.3846154 10.1538462,19.3846154 L12,19.3846154 C12.5076923,19.3846154 12.9230769,18.9692308 12.9230769,18.4615385 L12.9230769,12.9230769 C12.9230769,12.9230769 16.3569231,8.49230769 18.2215385,6.10153846 C18.6923077,5.49230769 18.2584615,4.61538462 17.4923077,4.61538462 L4.65230769,4.61538462 C3.88615385,4.61538462 3.45230769,5.49230769 3.92307692,6.10153846 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 .923 22.154 .923 22.154 23.077 0 23.077"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.8f3ef492.svg";
export { ForwardRef as ReactComponent };